import { screenWidthAtom } from "@/frontend/atoms/screenWidth/screenWidth";
import { useAtom } from "jotai";

export const useScreenWidth = () => {
  const [width] = useAtom(screenWidthAtom);

  return width;
};
